import { SvgIcon, SvgIconProps } from '@mui/material';

interface IconProps extends SvgIconProps {
  strokeWidth?: number;
}

export default function InspectorIcon(props: IconProps): JSX.Element {
  const { strokeWidth = 1.5 } = props;
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <g fill="none">
        <path
          d="M6.75003 6.75003V3.90003C6.74649 3.29378 7.10379 2.74348 7.65903 2.50003L11.409 0.873031C11.786 0.70899 12.2141 0.70899 12.591 0.873031L16.341 2.50003C16.8963 2.74348 17.2536 3.29378 17.25 3.90003V6.75003"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 3.375C11.7929 3.375 11.625 3.54289 11.625 3.75C11.625 3.95711 11.7929 4.125 12 4.125C12.2071 4.125 12.375 3.95711 12.375 3.75C12.375 3.54289 12.2071 3.375 12 3.375V3.375"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 6.75H18.75"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.6352 23.25C20.8955 18.5014 16.8061 14.9999 12.0002 15V15C7.19435 14.9999 3.10502 18.5014 2.36523 23.25"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 15.75L12 21.75L15.75 15.75"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4385 9C16.0749 11.1677 14.1985 12.7556 12.0005 12.7556C9.8025 12.7556 7.92611 11.1677 7.5625 9"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.79823 15.9492L6.11523 21.0002L9.86523 23.2502"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4772 16.0859L18.1152 20.9999L14.3652 23.2499"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
